module.exports = __webpack_public_path__ + "img/sub.d598abf4.png";